import React, { useEffect, useState } from 'react';
import { DashboardLayout } from '../../Components/Layout/DashboardLayout';
import CustomInput from '../../Components/CustomInput';
import { useGet, usePost } from '../../Api';
import { apiErrorMessage } from '../../Api/readJson';
import { SelectBox } from '../../Components/CustomSelect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import ImageUploader from '../../Components/ImageUpload';
import CustomModal from '../../Components/CustomModal';
import { useNotification } from '../../Components/GlobalNotification';
import { sanitizeInteger, sanitizeDecimal, sanitizeField, checkNumber, checkOptionalNumber } from './listingLimits';
import { dedupeTimings, canonicalTimingId } from './timingOptions';
import useListingLimits from './useListingLimits';

import { useNavigate } from 'react-router';

export const ListingForm = () => {
  const { showNotification } = useNotification();
  const { L, error: limitsError } = useListingLimits();
  const { ApiData: PlaceData, loading: PlaceLoading, error: PlaceError, get: GetPlace } = useGet(`/places`);
  const { ApiData: ListyingTypeData, loading: ListyingTypeLoading, error: ListyingTypeError, get: GetListyingType } = useGet(`/listing-types`);
  const { ApiData: SquareUnitData, loading: SquareUnitLoading, error: SquareUnitError, get: GetSquareUnit } = useGet(`/unit-of-measures`);
  const { ApiData: BedData, loading: BedLoading, error: BedError, get: GetBed } = useGet(`/bed-types`);
  const { ApiData: WeekData, loading: WeekLoading, error: WeekError, get: GetWeek } = useGet(`/weekend-days`);
  const { ApiData: FeeData, loading: FeeLoading, error: FeeError, get: GetFee } = useGet(`/fees-types`);
  const { ApiData: amenitiesData, loading: amenitiesLoading, error: amenitiesError, get: Getamenities } = useGet(`/amenities`);
  const { ApiData: facilitiesData, loading: facilitiesLoading, error: facilitiesError, get: Getfacilities } = useGet(`/facilities`);
  const { ApiData: timingData, loading: timingLoading, error: timingError, get: GetTiming } = useGet(`/listing-timings?per_page=100`);
  const { ApiData: AddListingData, loading: AddListingLoading, error: AddListingError, post: GetAddListing } = usePost(`/listings`);
  const { ApiData: DraftData, loading: DraftLoading, error: DraftError, post: SaveDraft } = usePost(`/listings`);
  const { ApiData: CountryData, loading: countriesLoading, error: countriesError, get: GetCountries } = useGet(`/countries`);
  const { ApiData: StateData, loading: statesLoading, error: statesError, get: GetStates } = useGet(`/state/by-country?country=0`);
  const { ApiData: CityData, loading: citiesLoading, error: citiesError, get: GetCities } = useGet(`/city/by-state?state=0`);
  const [imageIds, setImageIds] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [isMediaUploading, setIsMediaUploading] = useState(false);
  const [placeList, setPlaceList] = useState();
  const [listingList, setListingList] = useState();
  const [unitList, setUnitList] = useState();
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [bedType, setBedType] = useState();
  const [weekype, setWeekype] = useState();
  const [feeype, setFeeype] = useState();
  const [amenities, setAmenities] = useState();
  const [facilites, setFacilites] = useState();
  const [timing, setTiming] = useState();
  const navigate = useNavigate();


  useEffect(()=>{
    if(AddListingError) {
      showNotification({ type: 'error', title: 'Error', message: apiErrorMessage(AddListingError, 'Failed to add listing') })
    }
  },[AddListingError])

  // Handle Draft Save Response
  useEffect(() => {
    if (DraftData) {
      showNotification({ type: 'success', title: 'Success', message: DraftData?.message || 'Saved for later!' });
      setTimeout(() => {
        navigate('/draft-listings');
      }, 2000);
    }
  }, [DraftData]);

  // Handle Draft Save Error
  useEffect(() => {
    if (DraftError) {
      showNotification({ type: 'error', title: 'Error', message: DraftError?.message || 'Failed to save draft' });
    }
  }, [DraftError]);
 

  const [form, setForm] = useState(
    {
      "title": "",
      "description": "",
      "type_of_place": '',
      "type_of_listing": '',
      "bathrooms": '',
      "size": '',
      "unit_of_measure": '',
      "location": {
        "address": "",
        "suite": "",
        "country": "",
        "state": "",
        "city": "",
        "country_id": "",
        "state_id": "",
        "city_id": "",
        "zipcode": ""
      },
      "bedrooms": [
        {
          "bedroom_name": "",
          "no_of_guests": "",
          "no_of_beds": "",
          "bed_type": ''
        },
      ],
      "nightly": '',
      "weekends": '',
      "weekend_days": '',
      "weekly_per_night": '',
      "monthly_per_night": '',
      "additional_guest": '',
      "cleaning_fee_amount": '',
      "cleaning_fee_unit": "",
      "security_deposit": '',
      "local_tax_percent": '',
      "other_regional_taxes": '',
      "value_added_tax": '',
      "extra_service_fees": [
        {
          "name": "",
          "price": '',
          "type": ''
        }
      ],

      "cancellation_policy": "",
      "minimum_days_of_a_booking": '',
      "maximum_days_of_a_booking": '',
      "check_in_after": '',
      "check_out_by": '',
      "smoking_allowed": null,
      "pets_allowed": null,
      "gatherings_allowed": null,
      "children_allowed": null,
      "additional_rules": "",
      "available_dates": [],
      "not_available_dates": [],
      'amenity_id': [],
      'facility_id': [],
      'image_ids': []
    }
  )
  const [errors, setErrors] = useState({});
  const [currentStep, setCurrentStep] = useState(1);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    if (PlaceData) {
      setPlaceList(PlaceData?.data?.data)
    }
  }, [PlaceData]);


  useEffect(() => {
    if (ListyingTypeData) {
      setListingList(ListyingTypeData?.data?.data)
    }
  }, [ListyingTypeData]);


  useEffect(() => {
    if (SquareUnitData) {
      setUnitList(SquareUnitData?.data?.data)
    }
  }, [SquareUnitData]);

  useEffect(() => {
    if (CountryData) {
      console.log('[AddListing] CountryData:', CountryData);
      const list = Array.isArray(CountryData) ? CountryData : CountryData?.data || [];
      console.log('[AddListing] Parsed countryList:', list);
      setCountryList(list);
    }
  }, [CountryData]);

  useEffect(() => {
    if (StateData) {
      console.log('[AddListing] StateData:', StateData);
      const list = Array.isArray(StateData) ? StateData : StateData?.data || [];
      console.log('[AddListing] Parsed stateList:', list);
      setStateList(list);
    }
  }, [StateData]);

  useEffect(() => {
    if (CityData) {
      console.log('[AddListing] CityData:', CityData);
      const list = Array.isArray(CityData) ? CityData : CityData?.data || [];
      console.log('[AddListing] Parsed cityList:', list);
      setCityList(list);
    }
  }, [CityData]);


  useEffect(() => {
    if (BedData) {
      setBedType(BedData?.data?.data)
    }
  }, [BedData]);

  useEffect(() => {
    if (WeekData) {
      setWeekype(WeekData?.data?.data)
    }
  }, [WeekData]);


  useEffect(() => {
    if (FeeData) {
      setFeeype(FeeData?.data?.data)
    }
  }, [FeeData]);

  useEffect(() => {
    if (amenitiesData) {
      setAmenities(amenitiesData?.data?.data)
    }
  }, [amenitiesData]);

  useEffect(() => {
    if (facilitiesData) {
      setFacilites(facilitiesData?.data?.data)
    }
  }, [facilitiesData]);


  useEffect(() => {
    if (timingData) {
      setTiming(timingData?.data?.data)
    }
  }, [timingData]);

  // Initialize Google Places Autocomplete for address field (if Google script is loaded)
  useEffect(() => {
    const initAutocomplete = () => {
      if (!window.google || !window.google.maps || !document.getElementById('address')) return;

      const autocomplete = new window.google.maps.places.Autocomplete(
        document.getElementById('address'),
        { types: ['geocode'] }
      );

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (!place || !place.address_components) return;

        const components = place.address_components;
        const getComponent = (type) =>
          components.find((c) => c.types.includes(type))?.long_name || '';

        const postalCode = getComponent('postal_code');
        const countryName = getComponent('country');
        const stateName = getComponent('administrative_area_level_1');
        const cityName =
          getComponent('locality') ||
          getComponent('administrative_area_level_2') ||
          '';

        // Try to find country ID from loaded list
        const matchedCountry = countryList.find(c => c.name === countryName);
        const countryId = matchedCountry ? matchedCountry.id : '';
        if (countryId) {
          GetStates(`/state/by-country?country=${countryId}`, true);
        }

        setForm((prev) => ({
          ...prev,
          location: {
            ...prev.location,
            address: place.formatted_address || prev.location.address,
            zipcode: postalCode || prev.location.zipcode,
            country: countryName || prev.location.country,
            country_id: countryId || prev.location.country_id,
            state: stateName || prev.location.state,
            state_id: '',
            city: cityName || prev.location.city,
            city_id: '',
          },
        }));
      });
    };

    initAutocomplete();
  }, []);

  const handleImageIdsChange = (ids) => {
    const normalized = Array.isArray(ids) ? ids : [];
    setImageIds(normalized);
    setForm((prev) => ({ ...prev, image_ids: normalized }));
  };

  useEffect(() => {
    GetPlace()
    GetListyingType()
    GetSquareUnit()
    GetBed()
    GetWeek()
    GetFee()
    Getamenities()
    Getfacilities()
    GetTiming()
    GetCountries()
  }, [])

  const BOOKING_DAYS_MAX = L?.BOOKING_DAYS_MAX;

  const sanitizeBookingDays = (value) => {
    if (value === '' || value === null || value === undefined) return '';
    const digitsOnly = String(value).replace(/\D/g, '');
    if (!digitsOnly) return '';
    const num = Math.min(parseInt(digitsOnly, 10), BOOKING_DAYS_MAX);
    return String(num);
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    // handle boolean radio fields
    const booleanRadioFields = [
      'smoking_allowed',
      'pets_allowed',
      'gatherings_allowed',
      'children_allowed',
    ];

    let newValue = value;
    if (type === 'radio' && booleanRadioFields.includes(name)) {
      newValue = value === 'true';
    } else if (name === 'minimum_days_of_a_booking' || name === 'maximum_days_of_a_booking') {
      newValue = sanitizeBookingDays(value);
    } else if (L && sanitizeField(name, value, L) !== undefined) {
      newValue = sanitizeField(name, value, L);
    }

    setForm((prevForm) => ({
      ...prevForm,
      [name]: newValue
    }));

    // clear error for this field once user fills it
    setErrors((prev) => {
      const updated = { ...prev };
      if (newValue !== '' && newValue !== null && newValue !== undefined) {
        delete updated[name];
      }
      return updated;
    });

    console.log('data', form)
  };

  const handleAddBedroom = () => {
    if (form.bedrooms.length >= L.BEDROOMS_MAX) {
      showNotification({ type: 'error', title: 'Limit reached', message: `You can add at most ${L.BEDROOMS_MAX} bedrooms.` });
      return;
    }
    setForm(prev => ({
      ...prev,
      bedrooms: [...prev.bedrooms, { bedroom_name: '', no_of_guests: '', no_of_beds: '', bed_type: '' }]
    }));
  };

  // Convert string numeric fields to numbers before submitting so Laravel validation passes.
  const sanitizeNumericValues = (data) => {
    const numericFields = [
      'nightly', 'weekends', 'weekly_per_night', 'monthly_per_night',
      'cleaning_fee_amount', 'security_deposit', 'local_tax_percent',
      'other_regional_taxes', 'value_added_tax',
      'bathrooms', 'size', 'unit_of_measure'
    ];
    const parsed = { ...data };

    numericFields.forEach((field) => {
      if (parsed[field] === '' || parsed[field] === null || parsed[field] === undefined) {
        parsed[field] = null;
      } else {
        const num = parseFloat(parsed[field]);
        parsed[field] = !isNaN(num) ? num : parsed[field];
      }
    });

    if (Array.isArray(parsed.bedrooms)) {
      parsed.bedrooms = parsed.bedrooms.map((room) => ({
        ...room,
        no_of_guests: room.no_of_guests === '' || room.no_of_guests == null
          ? null
          : parseInt(room.no_of_guests, 10) || room.no_of_guests,
        no_of_beds: room.no_of_beds === '' || room.no_of_beds == null
          ? null
          : parseInt(room.no_of_beds, 10) || room.no_of_beds,
        bed_type: room.bed_type === '' || room.bed_type == null ? null : room.bed_type,
      }));
    }

    if (Array.isArray(parsed.extra_service_fees)) {
      parsed.extra_service_fees = parsed.extra_service_fees
        .filter((fee) => ['name', 'price', 'type'].some((key) => fee?.[key] !== '' && fee?.[key] != null && String(fee[key]).trim() !== ''))
        .map((fee) => ({
        ...fee,
        price: fee.price === '' || fee.price == null
          ? null
          : parseFloat(fee.price) || fee.price,
        type: fee.type === '' || fee.type == null ? null : fee.type,
      }));
    }

    return parsed;
  };


  const handleAddService = () => {
    if (form.extra_service_fees.length >= L.EXTRA_FEES_MAX) {
      showNotification({ type: 'error', title: 'Limit reached', message: `You can add at most ${L.EXTRA_FEES_MAX} extra service fees.` });
      return;
    }
    setForm(prev => ({
      ...prev,
      extra_service_fees: [...prev.extra_service_fees, { name: '', price: '', type: '' }]
    }));
  };


  const handleRemoveBedroom = (index) => {
    const updatedBedrooms = form.bedrooms.filter((_, i) => i !== index);
    setForm(prev => ({ ...prev, bedrooms: updatedBedrooms }));
  };

  const handleRemoveService = (index) => {
    const updatedBedrooms = form.extra_service_fees.filter((_, i) => i !== index);
    setForm(prev => ({ ...prev, extra_service_fees: updatedBedrooms }));
  };


  const handleChangeBedroom = (e, index = null, key = null) => {
    const { name, value } = e.target;

    if (index !== null && key) {
      const updatedBedrooms = [...form.bedrooms];
      updatedBedrooms[index][key] =
        key === 'no_of_guests' ? sanitizeInteger(value, L.GUESTS_PER_ROOM_MAX)
        : key === 'no_of_beds' ? sanitizeInteger(value, L.BEDS_PER_ROOM_MAX)
        : value;
      setForm(prev => ({ ...prev, bedrooms: updatedBedrooms }));

      // clear bedroom-related error when user updates it
      const errorKey = `${key}_${index}`;
      setErrors((prev) => {
        const updated = { ...prev };
        if (value !== '' && value !== null && value !== undefined) {
          delete updated[errorKey];
        }
        return updated;
      });
    } else {
      setForm(prev => ({ ...prev, [name]: value }));
    }

    console.log('testData', form)
  };


  const handleChangeService = (e, index = null, key = null) => {
    const { name, value } = e.target;

    if (index !== null && key) {
      const updatedBedrooms = [...form.extra_service_fees];
      updatedBedrooms[index][key] = key === 'price' ? sanitizeDecimal(value, L.PRICE_MAX) : value;
      setForm(prev => ({ ...prev, extra_service_fees: updatedBedrooms }));
    } else {
      setForm(prev => ({ ...prev, [name]: value }));
    }

    console.log('testData', form)
  };




  const handleLocationChange = (e) => {
    const { name, value } = e.target;

    // Country selected
    if (name === 'country') {
      if (value) {
        const selectedCountry = countryList.find(c => c.id == value);
        if (selectedCountry) {
          GetStates(`/state/by-country?country=${selectedCountry.id}`, true);
        }
        setForm((prev) => ({
          ...prev,
          location: {
            ...prev.location,
            country_id: value,
            country: selectedCountry ? selectedCountry.name : '',
            state_id: '',
            state: '',
            city_id: '',
            city: ''
          }
        }));
      } else {
        setStateList([]);
        setCityList([]);
        setForm((prev) => ({
          ...prev,
          location: {
            ...prev.location,
            country_id: '',
            country: '',
            state_id: '',
            state: '',
            city_id: '',
            city: ''
          }
        }));
      }
      setErrors((prev) => { const u = { ...prev }; delete u.country; delete u.state; delete u.city; return u; });
      return;
    }

    // State selected
    if (name === 'state') {
      if (value) {
        const selectedState = stateList.find(s => s.id == value);
        if (selectedState) {
          GetCities(`/city/by-state?state=${selectedState.id}`, true);
        }
        setForm((prev) => ({
          ...prev,
          location: {
            ...prev.location,
            state_id: value,
            state: selectedState ? selectedState.name : '',
            city_id: '',
            city: ''
          }
        }));
      } else {
        setCityList([]);
        setForm((prev) => ({
          ...prev,
          location: {
            ...prev.location,
            state_id: '',
            state: '',
            city_id: '',
            city: ''
          }
        }));
      }
      setErrors((prev) => { const u = { ...prev }; delete u.state; delete u.city; return u; });
      return;
    }

    // City selected
    if (name === 'city') {
      const selectedCity = cityList.find(c => c.id == value);
      setForm((prev) => ({
        ...prev,
        location: {
          ...prev.location,
          city_id: value,
          city: selectedCity ? selectedCity.name : ''
        }
      }));
      setErrors((prev) => { const u = { ...prev }; delete u.city; return u; });
      return;
    }

    // Other fields (address, suite, zipcode)
    setForm((prevForm) => ({
      ...prevForm,
      location: {
        ...prevForm.location,
        [name]: value
      }
    }));

    setErrors((prev) => {
      const updated = { ...prev };
      if (value !== '' && value !== null && value !== undefined) {
        delete updated[name];
      }
      return updated;
    });
  };

  const handleAmenityChange = (e) => {
    const value = parseInt(e.target.value); // Cast to number
    const { checked } = e.target;


    setForm((prevForm) => {
      const amenity_id = checked
        ? [...prevForm.amenity_id, value]
        : prevForm.amenity_id?.filter(item => item !== value);

      return {
        ...prevForm,
        amenity_id
      };
    });
  };


  const handleFacilitiesChange = (e) => {
    const value = parseInt(e.target.value); // Cast to number
    const { checked } = e.target;

    setForm((prevForm) => {
      const facility_id = checked
        ? [...prevForm.facility_id, value]
        : prevForm.facility_id.filter((item) => item !== value);

      return {
        ...prevForm,
        facility_id,
      };
    });
  };



  const validateStep = (step) => {
    const newErrors = {};
    let stepErrorKeys = [];

    if (step === 1) {
      stepErrorKeys = [
        'title',
        'type_of_place',
        'type_of_listing',
        'unit_of_measure',
        'bathrooms',
        'size',
        'description',
      ];
      if (!form.title?.trim()) newErrors.title = 'Title is required';
      else if (form.title.trim().length < L.TITLE_MIN) newErrors.title = `Title must be at least ${L.TITLE_MIN} characters`;
      else if (form.title.length > L.TITLE_MAX) newErrors.title = `Title must not exceed ${L.TITLE_MAX} characters`;
      if (!form.type_of_place) newErrors.type_of_place = 'Type of place is required';
      if (!form.type_of_listing) newErrors.type_of_listing = 'Type of listing is required';
      if (!form.unit_of_measure) newErrors.unit_of_measure = 'Unit of measure is required';
      const bathroomsErr = checkNumber(form.bathrooms, { label: 'Bathrooms', min: 0, max: L.BATHROOMS_MAX, integer: true });
      if (bathroomsErr) newErrors.bathrooms = bathroomsErr;
      const sizeErr = checkNumber(form.size, { label: 'Size', min: 1, max: L.SIZE_MAX, integer: true });
      if (sizeErr) newErrors.size = sizeErr;
      if (!form.description?.trim()) newErrors.description = 'Description is required';
      else if (form.description.length > 2000) newErrors.description = 'Description must not exceed 2000 characters';
    }

    if (step === 2) {
      stepErrorKeys = ['address', 'country', 'state', 'city', 'zipcode'];
      if (!form.location.address?.trim()) newErrors.address = 'Address is required';
      else if (form.location.address.length > 255) newErrors.address = 'Address must not exceed 255 characters';
      if (!form.location.country_id) newErrors.country = 'Country is required';
      if (!form.location.state_id) newErrors.state = 'State is required';
      if (!form.location.city_id) newErrors.city = 'City is required';
      if (!form.location.zipcode?.trim()) newErrors.zipcode = 'Postal code is required';
      else if (form.location.zipcode.length > 50) newErrors.zipcode = 'Postal code must not exceed 50 characters';
    }

    if (step === 3) {
      stepErrorKeys = [];
      form.bedrooms.forEach((bed, index) => {
        stepErrorKeys.push(
          `bedroom_name_${index}`,
          `no_of_guests_${index}`,
          `no_of_beds_${index}`,
          `bed_type_${index}`
        );
        if (!bed.bedroom_name?.trim()) newErrors[`bedroom_name_${index}`] = 'Bedroom name is required';
        else if (bed.bedroom_name.length > 255) newErrors[`bedroom_name_${index}`] = 'Bedroom name must not exceed 255 characters';
        const guestsErr = checkNumber(bed.no_of_guests, { label: 'No. guests', min: 1, max: L.GUESTS_PER_ROOM_MAX, integer: true });
        if (guestsErr) newErrors[`no_of_guests_${index}`] = guestsErr;
        const bedsErr = checkNumber(bed.no_of_beds, { label: 'No. beds', min: 1, max: L.BEDS_PER_ROOM_MAX, integer: true });
        if (bedsErr) newErrors[`no_of_beds_${index}`] = bedsErr;
        if (!bed.bed_type) newErrors[`bed_type_${index}`] = 'Bed type is required';
      });
      if (form.bedrooms.length > L.BEDROOMS_MAX) {
        newErrors[`bedroom_name_${L.BEDROOMS_MAX}`] = `You can add at most ${L.BEDROOMS_MAX} bedrooms`;
      }
      const totalGuests = form.bedrooms.reduce((sum, bed) => sum + (parseInt(bed.no_of_guests, 10) || 0), 0);
      if (totalGuests > L.TOTAL_GUESTS_MAX) {
        newErrors.no_of_guests_0 = `Total guests across all bedrooms must not exceed ${L.TOTAL_GUESTS_MAX} (currently ${totalGuests})`;
      }
    }

    if (step === 4) {
      stepErrorKeys = [
        'nightly',
        'weekends',
        'weekend_days',
        'weekly_per_night',
        'monthly_per_night',
        'cleaning_fee_amount',
        'cleaning_fee_unit',
        'security_deposit',
      ];
      const price = { max: L.PRICE_MAX };
      const pct = { max: L.PERCENT_MAX };
      const priceChecks = {
        nightly: checkNumber(form.nightly, { ...price, label: 'Nightly price', min: L.PRICE_MIN }),
        weekends: checkNumber(form.weekends, { ...price, label: 'Weekends price', min: L.PRICE_MIN }),
        weekly_per_night: checkNumber(form.weekly_per_night, { ...price, label: 'Weekly price', min: L.PRICE_MIN }),
        monthly_per_night: checkNumber(form.monthly_per_night, { ...price, label: 'Monthly price', min: L.PRICE_MIN }),
        cleaning_fee_amount: checkNumber(form.cleaning_fee_amount, { ...price, label: 'Cleaning fee' }),
        security_deposit: checkNumber(form.security_deposit, { ...price, label: 'Security deposit' }),
        local_tax_percent: checkOptionalNumber(form.local_tax_percent, { ...pct, label: 'Local tax' }),
        other_regional_taxes: checkOptionalNumber(form.other_regional_taxes, { ...pct, label: 'Other regional taxes' }),
        value_added_tax: checkOptionalNumber(form.value_added_tax, { ...pct, label: 'Value added tax' }),
      };
      Object.entries(priceChecks).forEach(([field, err]) => { if (err) newErrors[field] = err; });
      if (!form.weekend_days) newErrors.weekend_days = 'Weekend days selection is required';
      if (!form.cleaning_fee_unit) newErrors.cleaning_fee_unit = 'Cleaning fee unit is required';
      if ((form.extra_service_fees?.length || 0) > L.EXTRA_FEES_MAX) {
        newErrors.extra_service_fee_name_0 = `You can add at most ${L.EXTRA_FEES_MAX} extra service fees`;
      }

      form.extra_service_fees?.forEach((fee, index) => {
        stepErrorKeys.push(`extra_service_fee_name_${index}`, `extra_service_fee_price_${index}`, `extra_service_fee_type_${index}`);
        if (fee.name?.trim() || fee.price !== '' || fee.type) {
          if (!fee.name?.trim()) newErrors[`extra_service_fee_name_${index}`] = 'Fee name is required';
          if (fee.price === '' || fee.price == null) newErrors[`extra_service_fee_price_${index}`] = 'Fee price is required';
          else {
            const feeErr = checkNumber(fee.price, { label: 'Fee price', min: 0, max: L.PRICE_MAX });
            if (feeErr) newErrors[`extra_service_fee_price_${index}`] = feeErr;
          }
          if (!fee.type) newErrors[`extra_service_fee_type_${index}`] = 'Fee type is required';
        }
      });
    }

    if (step === 5) {
      stepErrorKeys = ['image_ids'];
      if (!form.image_ids || form.image_ids.length === 0) {
        newErrors.image_ids = 'At least one image is required';
      } else if (form.image_ids.length > L.IMAGES_MAX) {
        newErrors.image_ids = `You can upload at most ${L.IMAGES_MAX} images`;
      }
    }

    if (step === 6) {
      stepErrorKeys = ['amenity_id'];
      if (!form.amenity_id || form.amenity_id.length === 0) {
        newErrors.amenity_id = 'Select at least one amenity';
      }
      if (!form.facility_id || form.facility_id.length === 0) {
        newErrors.facility_id = 'Select at least one facility';
      }
    }

    if (step === 7) {
      stepErrorKeys = [
        'cancellation_policy',
        'minimum_days_of_a_booking',
        'maximum_days_of_a_booking',
        'check_in_after',
        'check_out_by',
        'smoking_allowed',
        'pets_allowed',
        'gatherings_allowed',
        'children_allowed',
        'additional_rules',
      ];
      if (!form.cancellation_policy) newErrors.cancellation_policy = 'Cancellation policy is required';
      if (form.additional_rules?.trim() && form.additional_rules.length > 2000) {
        newErrors.additional_rules = 'Additional rules must not exceed 2000 characters';
      }

      const minDays = Number(form.minimum_days_of_a_booking);
      const maxDays = Number(form.maximum_days_of_a_booking);

      if (!form.minimum_days_of_a_booking && form.minimum_days_of_a_booking !== 0) {
        newErrors.minimum_days_of_a_booking = 'Minimum days is required';
      } else if (!Number.isInteger(minDays) || minDays < 1 || minDays > BOOKING_DAYS_MAX) {
        newErrors.minimum_days_of_a_booking = `Enter a valid number between 1 and ${BOOKING_DAYS_MAX}`;
      }

      if (!form.maximum_days_of_a_booking && form.maximum_days_of_a_booking !== 0) {
        newErrors.maximum_days_of_a_booking = 'Maximum days is required';
      } else if (!Number.isInteger(maxDays) || maxDays < 1 || maxDays > BOOKING_DAYS_MAX) {
        newErrors.maximum_days_of_a_booking = `Enter a valid number between 1 and ${BOOKING_DAYS_MAX}`;
      } else if (!newErrors.minimum_days_of_a_booking && minDays > maxDays) {
        newErrors.maximum_days_of_a_booking = 'Maximum days must be greater than or equal to minimum days';
      }

      if (!form.check_in_after) newErrors.check_in_after = 'Check-in time is required';
      if (!form.check_out_by) newErrors.check_out_by = 'Check-out time is required';

      if (form.smoking_allowed === null || form.smoking_allowed === undefined) {
        newErrors.smoking_allowed = 'Please select smoking option';
      }
      if (form.pets_allowed === null || form.pets_allowed === undefined) {
        newErrors.pets_allowed = 'Please select pets option';
      }
      if (form.gatherings_allowed === null || form.gatherings_allowed === undefined) {
        newErrors.gatherings_allowed = 'Please select gatherings option';
      }
      if (form.children_allowed === null || form.children_allowed === undefined) {
        newErrors.children_allowed = 'Please select children option';
      }

    }

    // Clear previous errors for this step, then apply new ones
    if (stepErrorKeys.length) {
      setErrors((prev) => {
        const updated = { ...prev };
        stepErrorKeys.forEach((key) => {
          delete updated[key];
        });
        return { ...updated, ...newErrors };
      });
    } else {
      setErrors(prev => ({ ...prev, ...newErrors }));
    }

    if (Object.keys(newErrors).length) {
      showNotification({ type: 'error', title: 'Error', message: (() => {
          const problems = Object.values(newErrors);
          const shown = problems.slice(0, 3).join('. ');
          return `Please fix the following before continuing: ${shown}${problems.length > 3 ? ` (+${problems.length - 3} more)` : ''}.`;
        })() });
      return false;
    }

    return true;
  };

  const handleStepChange = (step) => {
    // Only validate when moving forward
    if (step > currentStep && !validateStep(currentStep)) {
      return;
    }
    setCurrentStep(step);
  };

  const [images, setImages] = useState([]);

  const handleImagesChange = (files) => {
    setImages(files);
    console.log('Images in parent:', files);
  };
  

  const handleSubmit = (e) => {
    e.preventDefault();

    // validate last step as well as previous important ones
    const stepsToValidate = [1, 2, 3, 4, 5, 6, 7];
    const allValid = stepsToValidate.every(step => validateStep(step));

    if (!allValid) return;

    GetAddListing(sanitizeNumericValues(form));
    console.log(form);
  };

  // Handle Save for Later (Draft) — saves everything filled so far, no validation required
  const handleSaveAsDraft = () => {
    if (!form.title?.trim()) {
      showNotification({ type: 'error', title: 'Error', message: 'Please enter a title before saving as draft.' });
      return;
    }
    SaveDraft({ ...sanitizeNumericValues(form), save_as_draft: 'true' });
  };

  

  useEffect(() => {
    if (AddListingData) {
      showNotification({ type: 'info', title: 'Information', message: AddListingData?.message });
      setShowSuccessModal(true);
      setTimeout(() => {
        setShowSuccessModal(false);
        navigate('/listing-management');
      }, 3000);
    }
  }, [AddListingData]);

  // Limits come from the admin-managed Listing Rules; the form cannot validate without them.
  if (!L) {
    return (
      <DashboardLayout>
        <div className="p-4 text-center">
          {limitsError
            ? <p className="text-danger">Could not load the listing rules. Please refresh the page or try again later.</p>
            : <p>Loading listing rules...</p>}
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="container-fluid">
        <div className='row mb-3 justify-content-center'>
          <div className='col-md-10'>
            <div className="dashCard">
              <div className='row mb-3 justify-content-between'>
                <div className="col-md-6 mb-2">
                  <h2 className="mainTitle">Add New Listing</h2>
                </div>
              </div>

              <form onSubmit={handleSubmit}>
              {/* Step 1: Basic Info */}
              {currentStep === 1 && (
                <div className="step">
                  <h4 className='subTitke'>Information</h4>

                  <div className='row'>
                    <div className='mb-3 col-md-12'>
                      <div className="form-group">
                        <CustomInput
                          label="Title"
                          type="text"
                          required
                          maxLength={255}
                          labelClass='mainLabel'
                          inputClass='mainInput'
                          id="title"
                          name="title"
                          value={form.title}
                          onChange={handleChange}
                        />
                        {errors.title && <small className="text-danger">{errors.title}</small>}
                      </div>
                    </div>
                    <div className='mb-3 col-md-4'>
                      <div className="form-group">
                        <SelectBox
                          label="Type of Place"
                          required
                          placeholder="Select Type of Place"
                          name="type_of_place"
                          value={form.type_of_place}
                          option={placeList}
                          selectClass="mainInput"
                          onChange={handleChange}
                        />
                        {errors.type_of_place && <small className="text-danger">{errors.type_of_place}</small>}

                      </div>
                    </div>
                    <div className='mb-3 col-md-4'>
                      <div className="inputWrapper">
                        <label className='mainLabel'>Type of Listing</label>
                        <div className="fieldData">
                          <select className='mainInput' name='type_of_listing' onChange={handleChange} value={form.type_of_listing}>
                            <option value="" className='text-capitalize'>
                              Select Type of Listing
                            </option>
                            {Array.isArray(listingList) && listingList?.map(item => (

                              <option value={item?.id}>{item?.listing_name}</option>
                            ))
                            }
                          </select>
                          {errors.type_of_listing && <small className="text-danger">{errors.type_of_listing}</small>}

                        </div>
                      </div>
                    </div>
                    <div className='mb-3 col-md-4'>
                      <div className="inputWrapper">
                        <label className='mainLabel'>Unit of Measure</label>
                        <div className="fieldData">
                          <select className='mainInput' name='unit_of_measure' onChange={handleChange} value={form.unit_of_measure}>
                            <option value="" className='text-capitalize'>
                              Select Unit of Measure
                            </option>
                            {Array.isArray(unitList) && unitList?.map(item => (

                              <option value={item?.id}>{item?.measure_name}</option>
                            ))
                            }
                          </select>
                          {errors.unit_of_measure && <small className="text-danger">{errors.unit_of_measure}</small>}

                        </div>
                      </div>
                    </div>
                    <div className='mb-3 col-md-6'>
                      <div className="form-group">
                        <CustomInput
                          type="number"
                          label="Bathrooms"
                          required
                          labelClass='mainLabel'
                          inputClass='mainInput'
                          id="bathrooms"
                          name="bathrooms"
                          value={form.bathrooms}
                          onChange={handleChange}
                        />
                        {errors.bathrooms && <small className="text-danger">{errors.bathrooms}</small>}
                      </div>
                    </div>
                    <div className='mb-3 col-md-6'>
                      <div className="form-group">
                        <CustomInput
                          type="number"
                          label="Size of living area"
                          required
                          labelClass='mainLabel'
                          inputClass='mainInput'
                          id="size"
                          name="size"
                          value={form.size}
                          onChange={handleChange}
                        />
                        {errors.size && <small className="text-danger">{errors.size}</small>}
                      </div>
                    </div>
                    <div className='mb-3 col-md-12'>
                      <div className="form-group">
                        <label htmlFor="description" className='mainLabel'>Description</label>
                        <textarea rows={8}
                          className='mainInput listingDescription'
                          name='description'
                          maxLength={2000}
                          value={form.description}
                          onChange={handleChange}
                        ></textarea>
                        {errors.description && <small className="text-danger">{errors.description}</small>}

                      </div>
                    </div>
                  </div>
                  <div className='mb-3 col-md-12'>
                    <div className='stepButon d-flex justify-content-end'>
                      <button type="button" className="btn btn-primary" onClick={() => handleStepChange(2)}>
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Step 2: Location */}
              {currentStep === 2 && (
                <div className="step">
                  <h4 className='subTitke'>Location</h4>
                  <div className='row'>
                    <div className='mb-3 col-md-4'>
                      <div className="form-group">
                        <CustomInput
                          type="text"
                          label="Address"
                          required
                          maxLength={255}
                          labelClass='mainLabel'
                          inputClass='mainInput'
                          id="address"
                          name="address"
                          value={form.location.address}
                          onChange={handleLocationChange}
                        />
                        {errors.address && <small className="text-danger">{errors.address}</small>}
                      </div>
                    </div>
                    <div className='mb-3 col-md-4'>
                      <div className="form-group">
                        <CustomInput
                          type="text"
                          label="Apt, Suite"
                          maxLength={255}
                          labelClass='mainLabel'
                          inputClass='mainInput'
                          id="suite"
                          name="suite"
                          value={form.location.suite}
                          onChange={handleLocationChange}
                        />
                      </div>
                    </div>
                    <div className='mb-3 col-md-4'>
                      <div className="inputWrapper">
                        <label className='mainLabel'>Country*</label>
                        <div className="fieldData">
                          <select className='mainInput' name='country' onChange={handleLocationChange} value={form.location.country_id} disabled={countriesLoading}>
                            <option value="" className='text-capitalize'>{countriesLoading ? 'Loading countries...' : 'Select Country'}</option>
                            {Array.isArray(countryList) && countryList?.map(item => (
                              <option key={item?.id} value={item?.id}>{item?.name}</option>
                            ))}
                          </select>
                          {countriesError && <small className="text-danger">Failed to load countries. Please refresh.</small>}
                          {errors.country && <small className="text-danger">{errors.country}</small>}
                        </div>
                      </div>
                    </div>
                    <div className='mb-3 col-md-4'>
                      <div className="inputWrapper">
                        <label className='mainLabel'>State*</label>
                        <div className="fieldData">
                          <select className='mainInput' name='state' onChange={handleLocationChange} value={form.location.state_id} disabled={statesLoading || !form.location.country_id}>
                            <option value="" className='text-capitalize'>{statesLoading ? 'Loading states...' : 'Select State'}</option>
                            {Array.isArray(stateList) && stateList?.map(item => (
                              <option key={item?.id} value={item?.id}>{item?.name}</option>
                            ))}
                          </select>
                          {statesError && <small className="text-danger">Failed to load states.</small>}
                          {errors.state && <small className="text-danger">{errors.state}</small>}
                        </div>
                      </div>
                    </div>
                    <div className='mb-3 col-md-4'>
                      <div className="inputWrapper">
                        <label className='mainLabel'>City*</label>
                        <div className="fieldData">
                          <select className='mainInput' name='city' onChange={handleLocationChange} value={form.location.city_id} disabled={citiesLoading || !form.location.state_id}>
                            <option value="" className='text-capitalize'>{citiesLoading ? 'Loading cities...' : 'Select City'}</option>
                            {Array.isArray(cityList) && cityList?.map(item => (
                              <option key={item?.id} value={item?.id}>{item?.name}</option>
                            ))}
                          </select>
                          {citiesError && <small className="text-danger">Failed to load cities.</small>}
                          {errors.city && <small className="text-danger">{errors.city}</small>}
                        </div>
                      </div>
                    </div>
                    <div className='mb-3 col-md-4'>
                      <CustomInput
                        type="text"
                        labelClass='mainLabel'
                        inputClass='mainInput'
                        label="ZIP/Postal code"
                        required
                        maxLength={50}
                        id="zipcode"
                        name="zipcode"
                        value={form.location.zipcode}
                        onChange={handleLocationChange}
                      />
                      {errors.zipcode && <small className="text-danger">{errors.zipcode}</small>}
                    </div>

                  </div>
                  <div className='mb-3 col-md-12'>
                    <div className='stepButon d-flex justify-content-between'>
                      <button type="button" className="btn btn-secondary" onClick={() => handleStepChange(1)}>
                        Back
                      </button>
                      <div className="d-flex gap-2">
                        <button 
                          type="button" 
                          className="btn btn-outline-warning" 
                          onClick={handleSaveAsDraft}
                          disabled={DraftLoading}
                        >
                          {DraftLoading ? 'Saving...' : 'Save for Later'}
                        </button>
                        <button type="button" className="btn btn-primary" onClick={() => handleStepChange(3)}>
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Step 3: Bedrooms */}
              {currentStep === 3 && (
                <div className="step">
                  <h4 className='subTitke'>Bedrooms</h4>
                  {form?.bedrooms?.map((item, index) => (
                    <div className='row' key={index}>
                      <div className='mb-3 col-md-12'>
                        <div className='d-flex justify-content-end mb-2'>
                          <button type='button' className='btn btn-success me-2' onClick={handleAddBedroom}>
                            <FontAwesomeIcon icon={faPlus} /> Add Another Room
                          </button>
                          {form.bedrooms.length > 1 && (
                            <button type='button' className='btn btn-danger' onClick={() => handleRemoveBedroom(index)}>
                              <FontAwesomeIcon icon={faTrash} /> Remove
                            </button>
                          )}
                        </div>
                      </div>

                      <div className='mb-3 col-md-6'>
                        <CustomInput
                          type="text"
                          label={`Bedroom Name ${index + 1}`}
                          required
                          maxLength={255}
                          labelClass='mainLabel'
                          inputClass='mainInput'
                          id={`bedroom_name_${index}`}
                          name="bedroom_name"
                          value={item?.bedroom_name}
                          onChange={(e) => handleChangeBedroom(e, index, 'bedroom_name')}
                        />
                        {errors[`bedroom_name_${index}`] && <small className="text-danger">{errors[`bedroom_name_${index}`]}</small>}
                      </div>

                      <div className='mb-3 col-md-6'>
                        <CustomInput
                          type="number"
                          label="No. Guests"
                          required
                          labelClass='mainLabel'
                          inputClass='mainInput'
                          id={`no_of_guest_${index}`}
                          name="no_of_guests"
                          value={item?.no_of_guests}
                          onChange={(e) => handleChangeBedroom(e, index, 'no_of_guests')}
                        />
                        {errors[`no_of_guests_${index}`] && <small className="text-danger">{errors[`no_of_guests_${index}`]}</small>}
                      </div>

                      <div className='mb-3 col-md-6'>
                        <CustomInput
                          type="number"
                          label="No. Beds"
                          required
                          labelClass='mainLabel'
                          inputClass='mainInput'
                          id={`no_of_bed_${index}`}
                          name="no_of_beds"
                          value={item?.no_of_beds}
                          onChange={(e) => handleChangeBedroom(e, index, 'no_of_beds')}
                        />
                        {errors[`no_of_beds_${index}`] && <small className="text-danger">{errors[`no_of_beds_${index}`]}</small>}
                      </div>

                      <div className='mb-3 col-md-6'>
                        <div className="inputWrapper">
                          <label className='mainLabel'>Bed Type</label>
                          <div className="fieldData">
                            <select
                              className='mainInput'
                              name='bed_type'
                              value={item?.bed_type}
                              onChange={(e) => handleChangeBedroom(e, index, 'bed_type')}
                            >
                              <option value="">Select Bed Type</option>
                              {Array.isArray(bedType) && bedType
                                ?.filter((data) => !['twin', 'full'].includes((data?.bed_name || '').toLowerCase()))
                                ?.map((data, i) => (
                                <option key={i} value={data?.id}>{data?.bed_name}</option>
                              ))}
                            </select>
                            {errors[`bed_type_${index}`] && <small className="text-danger">{errors[`bed_type_${index}`]}</small>}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  <div className='mb-3 col-md-12'>
                    <div className='stepButon d-flex justify-content-between'>
                      <button type="button" className="btn btn-secondary" onClick={() => handleStepChange(2)}>
                        Back
                      </button>
                      <div className="d-flex gap-2">
                        <button type="button" className="btn btn-outline-warning" onClick={handleSaveAsDraft} disabled={DraftLoading}>
                          {DraftLoading ? 'Saving...' : 'Save for Later'}
                        </button>
                        <button type="button" className="btn btn-primary" onClick={() => handleStepChange(4)}>
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Step 3: Pricing */}
              {currentStep === 4 && (
                <div className="step">
                  <h4 className='subTitke'>Pricing</h4>
                  <div className='row'>
                    <div className='mb-3 col-md-4'>
                      <div className="form-group">
                        <CustomInput
                          type="number"
                          label="Nightly"
                          placeholder="$"
                          required
                          labelClass='mainLabel'
                          inputClass='mainInput'
                          id="Nightly"
                          name="nightly"
                          value={form.nightly}
                          onChange={handleChange}
                        />
                        {errors.nightly && <small className="text-danger">{errors.nightly}</small>}
                      </div>
                    </div>
                    <div className='mb-3 col-md-4'>
                      <div className="form-group">
                      <CustomInput
                        type="number"
                        label="Weekends"
                        labelClass='mainLabel'
                        inputClass='mainInput'
                        id="weekends"
                        name="weekends"
                        value={form.weekends}
                        onChange={handleChange}
                      />
                      {errors.weekends && <small className="text-danger">{errors.weekends}</small>}
                      </div>
                    </div>
                    <div className='mb-3 col-md-4'>
                      <div className="inputWrapper">
                        <label className='mainLabel'>Select the days to apply weekend pricing</label>
                        <div className="fieldData">
                          <select className='mainInput' name='weekend_days' onChange={handleChange} value={form.weekend_days}>
                            <option value="" className='text-capitalize'>Select the days</option>
                            {Array.isArray(weekype) && weekype?.map(item => (

                              <option value={item?.id}>{item?.days_name}</option>
                            ))
                            }
                          </select>
                          {errors.weekend_days && <small className="text-danger d-block">{errors.weekend_days}</small>}

                        </div>
                      </div>
                    </div>
                    <div className='mb-3 col-md-12'>
                      <div className='subHeadTitle'>
                        <h5>Long-term pricing </h5>
                      </div>
                    </div>
                    <div className='mb-3 col-md-6'>
                      <CustomInput
                        type="number"
                        label="Weekly - 7+ nights"
                        placeholder="Price Per Night"
                        required
                        labelClass='mainLabel'
                        inputClass='mainInput'
                        id="Nigprice_per_nighthtly"
                        name="weekly_per_night"
                        value={form.weekly_per_night}
                        onChange={handleChange}
                      />
                      {errors.weekly_per_night && <small className="text-danger">{errors.weekly_per_night}</small>}
                    </div>

                    <div className='mb-3 col-md-6'>
                      <CustomInput
                        type="number"
                        label="Monthly - 30+ night"
                        placeholder="Price Per Night"
                        required
                        labelClass='mainLabel'
                        inputClass='mainInput'
                        id="Nigprice_per_nighthtly"
                        name="monthly_per_night"
                        value={form.monthly_per_night}
                        onChange={handleChange}
                      />
                      {errors.monthly_per_night && <small className="text-danger">{errors.monthly_per_night}</small>}
                    </div>

                    <div className='mb-3 col-md-12'>
                      <div className='subHeadTitle'>
                        <h5>Additional Cost </h5>
                      </div>
                    </div>

                    <div className='mb-3 col-md-2'>
                      <div className='form-group'>
                        <input
                          type='radio'
                          name="cleaning_fee_unit"
                          id="daily"
                          value="daily"
                          checked={form.cleaning_fee_unit === 'daily'}
                          onChange={handleChange}
                        />
                        <label htmlFor="daily" className='mx-2 mt-4'>Daily</label>
                      </div>
                    </div>

                    <div className='mb-3 col-md-2'>
                      <div className='form-group'>
                        <input
                          type='radio'
                          name="cleaning_fee_unit"
                          id="perstay"
                          value='perstay'
                          checked={form.cleaning_fee_unit === 'perstay'}
                          onChange={handleChange}
                        />
                        <label htmlFor="perstay" className='mx-2 mt-4'>Per Stay</label>
                      </div>
                    </div>
                    <div className='mb-3 col-md-4'>
                      {errors.cleaning_fee_unit && <small className="text-danger">{errors.cleaning_fee_unit}</small>}
                    </div>

                    <div className='mb-3 col-md-4'>
                      <CustomInput
                        type="number"
                        label="Cleaning fee"
                        placeholder="$"
                        required
                        labelClass='mainLabel'
                        inputClass='mainInput'
                        id="cleaning"
                        name="cleaning_fee_amount"
                        value={form.cleaning_fee_amount}
                        onChange={handleChange}
                      />
                      {errors.cleaning_fee_amount && <small className="text-danger">{errors.cleaning_fee_amount}</small>}
                    </div>




                    <div className='mb-3 col-md-4'>
                      <CustomInput
                        type="number"
                        label="Security deposit"
                        placeholder="$"
                        required
                        labelClass='mainLabel'
                        inputClass='mainInput'
                        id="security"
                        name="security_deposit"
                        value={form.security_deposit}
                        onChange={handleChange}
                      />
                      {errors.security_deposit && <small className="text-danger">{errors.security_deposit}</small>}
                    </div>


                    <div className='mb-3 col-md-4'>
                      <CustomInput
                        type="number"
                        label="Local Tax %"
                        placeholder="%"
                        labelClass='mainLabel'
                        inputClass='mainInput'
                        id="local"
                        name="local_tax_percent"
                        value={form.local_tax_percent}
                        onChange={handleChange}
                      />
                      {errors.local_tax_percent && <small className="text-danger">{errors.local_tax_percent}</small>}
                    </div>


                    <div className='mb-3 col-md-4'>
                      <CustomInput
                        type="number"
                        label="Other Regional Taxes"
                        placeholder="%"
                        labelClass='mainLabel'
                        inputClass='mainInput'
                        id="regiona_tax"
                        name="other_regional_taxes"
                        value={form.other_regional_taxes}
                        onChange={handleChange}
                      />
                      {errors.other_regional_taxes && <small className="text-danger">{errors.other_regional_taxes}</small>}
                    </div>


                    <div className='mb-3 col-md-4'>
                      <CustomInput
                        type="number"
                        label="Value Added Tax or equivalent (If applicable)"
                        placeholder="%"
                        labelClass='mainLabel'
                        inputClass='mainInput'
                        id="value_tax"
                        name="value_added_tax"
                        value={form.value_added_tax}
                        onChange={handleChange}
                      />
                      {errors.value_added_tax && <small className="text-danger">{errors.value_added_tax}</small>}
                    </div>

                    <div className='mb-3 col-md-12'>
                      <p className='text-danger'>* It is the host’s responsibility to know the tax regulations pertaining to the region of the rental property, to calculate and list taxes, and to remit those taxes to the appropriate officials.</p>
                    </div>


                    <div className='mb-3 col-md-12'>
                      <div className='subHeadTitle'>
                        <h5>Extra Service Fees</h5>
                      </div>

                      {form?.extra_service_fees?.map((item, index) => (
                        <div className='row' key={index}>
                          <div className='mb-3 col-md-12'>
                            <div className='d-flex justify-content-end mb-2'>
                              <button type='button' className='btn btn-success me-2' onClick={handleAddService}>
                                <FontAwesomeIcon icon={faPlus} /> Add More
                              </button>
                              {form.extra_service_fees.length > 0 && (
                                <button type='button' className='btn btn-danger' onClick={() => handleRemoveService(index)}>
                                  <FontAwesomeIcon icon={faTrash} /> Remove
                                </button>
                              )}
                            </div>
                          </div>

                          <div className='mb-3 col-md-4'>
                            <CustomInput
                              type="text"
                              label={`Name`}
                              maxLength={255}
                              labelClass='mainLabel'
                              inputClass='mainInput'
                              id={`name`}
                              value={item?.name}
                              name="name"
                              onChange={(e) => handleChangeService(e, index, 'name')}
                            />
                            {errors[`extra_service_fee_name_${index}`] && <small className="text-danger">{errors[`extra_service_fee_name_${index}`]}</small>}
                          </div>

                          <div className='mb-3 col-md-4'>
                            <CustomInput
                              type="number"
                              label="Price"
                              labelClass='mainLabel'
                              inputClass='mainInput'
                              id={`price`}
                              value={item?.price}
                              name="price"
                              onChange={(e) => handleChangeService(e, index, 'price')}
                            />
                            {errors[`extra_service_fee_price_${index}`] && <small className="text-danger">{errors[`extra_service_fee_price_${index}`]}</small>}
                          </div>

                          <div className='mb-3 col-md-4'>
                            <div className="inputWrapper">
                              <label className='mainLabel'>Type</label>
                              <div className="fieldData">
                                <select
                                  className='mainInput'
                                  name='type'
                                  value={item?.type}
                                  onChange={(e) => handleChangeService(e, index, 'type')}
                                >
                                  <option value="">Select Fee Type</option>
                                  {Array.isArray(feeype) && feeype?.map((data, i) => (
                                    <option key={i} value={data?.id}>{data?.fees_name}</option>
                                  ))}
                                </select>
                                {errors[`extra_service_fee_type_${index}`] && <small className="text-danger">{errors[`extra_service_fee_type_${index}`]}</small>}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                  </div>
                  <div className='mb-3 col-md-12'>
                    <div className='stepButon d-flex justify-content-between'>
                      <button type="button" className="btn btn-secondary" onClick={() => handleStepChange(3)}>
                        Back
                      </button>
                      <div className="d-flex gap-2">
                        <button type="button" className="btn btn-outline-warning" onClick={handleSaveAsDraft} disabled={DraftLoading}>
                          {DraftLoading ? 'Saving...' : 'Save for Later'}
                        </button>
                        <button type="button" className="btn btn-primary" onClick={() => handleStepChange(5)}>
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}


              {currentStep === 5 && (
                <div className="step">
                  <h4 className='subTitke'>Media</h4>
                  <ImageUploader
                    multiple={true}
                    initialImages={uploadedImages}
                    onChange={handleImageIdsChange}
                    onImagesChange={setUploadedImages}
                    onUploadingChange={setIsMediaUploading}
                    maxImages={L.IMAGES_MAX}
                    maxFileMb={L.IMAGE_MAX_MB}
                  />
                  {errors.image_ids && <small className="text-danger d-block mt-2">{errors.image_ids}</small>}
                  <div className='mb-3 col-md-12'>
                    <div className='stepButon d-flex justify-content-between'>
                      <button type="button" className="btn btn-secondary" onClick={() => handleStepChange(4)}>
                        Back
                      </button>
                      <div className="d-flex gap-2">
                        <button type="button" className="btn btn-outline-warning" onClick={handleSaveAsDraft} disabled={DraftLoading}>
                          {DraftLoading ? 'Saving...' : 'Save for Later'}
                        </button>
                        <button type="button" className="btn btn-primary" onClick={() => handleStepChange(6)} disabled={isMediaUploading}>
                          {isMediaUploading ? 'Uploading...' : 'Next'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}


              {/* amenities and facilities  */}


              {currentStep === 6 && (
                <div className="step">
                  <h4 className='subTitke'>Features</h4>
                  <div className='row'>
                    <div className='mb-3 col-md-12'>
                      <div className='subHeadTitle'>
                        <h5>Amenities</h5>
                      </div>
                    </div>
                    {
                      amenities && amenities.map((item, index) => (
                        <div className='mb-3 col-md-4 col-lg-3' key={index}>
                          <label htmlFor={`amen-${index}`} className='feature-checkbox d-flex align-items-center gap-2'>
                            <input
                              type="checkbox"
                              name="amenity_id"
                              value={item?.id}
                              id={`amen-${index}`}
                              checked={form.amenity_id.includes(item?.id)}
                              onChange={(e) => handleAmenityChange(e)}
                            />
                            <span>{item?.amenity_name}</span>
                          </label>
                        </div>
                      ))
                    }
                    {errors.amenity_id && <div className='col-12'><small className="text-danger">{errors.amenity_id}</small></div>}


                    <div className='mb-3 col-md-12'>
                      <div className='subHeadTitle'>
                        <h5>Facilities</h5>
                      </div>
                    </div>
                    {
                      facilites && facilites?.map((item, index) => (
                        <div className='mb-3 col-md-4 col-lg-3' key={index}>
                          <label htmlFor={`facility-${index}`} className='feature-checkbox d-flex align-items-center gap-2'>
                            <input
                              type="checkbox"
                              name="facility_id"
                              value={item?.id}
                              id={`facility-${index}`}
                              checked={form?.facility_id?.includes(item?.id)}
                              onChange={(e) => handleFacilitiesChange(e)}
                            />
                            <span>{item?.facility_name}</span>
                          </label>
                        </div>
                      ))
                    }
                    {errors.facility_id && <div className='col-12'><small className="text-danger">{errors.facility_id}</small></div>}
                    <div className='mb-3 col-md-12'>
                      <div className='stepButon d-flex justify-content-between'>
                        <button type="button" className="btn btn-secondary" onClick={() => handleStepChange(5)}>
                          Back
                        </button>
                        <div className="d-flex gap-2">
                          <button type="button" className="btn btn-outline-warning" onClick={handleSaveAsDraft} disabled={DraftLoading}>
                            {DraftLoading ? 'Saving...' : 'Save for Later'}
                          </button>
                          <button type="button" className="btn btn-primary" onClick={() => handleStepChange(7)}>
                            Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {currentStep === 7 && (
                <div className="step">
                  <h4 className='subTitke'>Terms & rules
                  </h4>
                  <div className='row'>
                    <div className='mb-3 col-md-4'>
                      <div className="inputWrapper">
                        <label className='mainLabel'>Cancellation Policy</label>
                        <div className="fieldData">
                          <select className='mainInput' name='cancellation_policy' onChange={handleChange} value={form.cancellation_policy}>
                            <option value="">
                              Select Policy
                            </option>
                            <option value="No Refund">No Refund</option>
                            <option value="Limited">Limited</option>
                            <option value="Relaxed">Relaxed</option>
                          </select>
                        </div>
                        {errors.cancellation_policy && <small className="text-danger">{errors.cancellation_policy}</small>}
                      </div>
                    </div>
                    <div className='mb-3 col-md-4'>
                      <div className="form-group">
                        <CustomInput
                          type="text"
                          inputMode="numeric"
                          maxLength={3}
                          label="Minimum days of a booking"
                          required
                          labelClass='mainLabel'
                          inputClass='mainInput'
                          id="minimum_days_of_a_booking"
                          name="minimum_days_of_a_booking"
                          value={form.minimum_days_of_a_booking}
                          onChange={handleChange}
                        />
                        {errors.minimum_days_of_a_booking && <small className="text-danger">{errors.minimum_days_of_a_booking}</small>}
                      </div>
                    </div>

                    <div className='mb-3 col-md-4'>
                      <div className="form-group">
                        <CustomInput
                          type="text"
                          inputMode="numeric"
                          maxLength={3}
                          label="Maximum days of a booking*"
                          required
                          labelClass='mainLabel'
                          inputClass='mainInput'
                          id="maximum_days_of_a_booking"
                          name="maximum_days_of_a_booking"
                          value={form.maximum_days_of_a_booking}
                          onChange={handleChange}
                        />
                        {errors.maximum_days_of_a_booking && <small className="text-danger">{errors.maximum_days_of_a_booking}</small>}
                      </div>
                    </div>
                    <div className='mb-3 col-md-6'>
                      <div className="inputWrapper">
                        <label className='mainLabel'>Check-in After*</label>
                        <div className="fieldData">
                          <select className='mainInput' name='check_in_after' onChange={handleChange} value={canonicalTimingId(timing, form?.check_in_after)}>
                            <option value="">
                              Select Check-in
                            </option>
                            {Array.isArray(timing) && dedupeTimings(timing).map((item) => (
                              <option key={item?.id} value={item?.id}>{item?.time}</option>
                            ))}
                          </select>
                        </div>
                        {errors.check_in_after && <small className="text-danger">{errors.check_in_after}</small>}
                      </div>
                    </div>

                    <div className='mb-3 col-md-6'>
                      <div className="inputWrapper">
                        <label className='mainLabel'>Check-out By*</label>
                        <div className="fieldData">
                          <select className='mainInput' name='check_out_by' onChange={handleChange} value={canonicalTimingId(timing, form?.check_out_by)}>
                            <option value="">
                              Select Check-out
                            </option>
                            {Array.isArray(timing) && dedupeTimings(timing).map((item) => (
                              <option key={item?.id} value={item?.id}>{item?.time}</option>
                            ))}
                          </select>
                        </div>
                        {errors.check_out_by && <small className="text-danger">{errors.check_out_by}</small>}
                      </div>
                    </div>
                    <div className='mb-3 col-md-3'>
                      <div className='radioButon'>
                        <h6 className='mainLabel'>Smoking allowed?</h6>
                        <div className='d-inline mx-2'>
                          <label className='px-2 mainLabel' htmlFor="smoking_yes">Yes</label>
                          <input
                            type='radio'
                            name="smoking_allowed"
                            id="smoking_yes"
                            value="true"
                            checked={form.smoking_allowed === true}
                            onChange={handleChange}
                          />
                        </div>
                        <div className='d-inline mx-2'>
                          <label className='px-2 mainLabel' htmlFor="smoking_no">No</label>
                          <input
                            type='radio'
                            name="smoking_allowed"
                            id="smoking_no"
                            value="false"
                            checked={form.smoking_allowed === false}
                            onChange={handleChange}
                          />
                        </div>
                        {errors.smoking_allowed && <small className="text-danger d-block mt-1">{errors.smoking_allowed}</small>}
                      </div>
                    </div>

                    <div className='mb-3 col-md-3'>
                      <div className='radioButon'>
                        <h6 className='mainLabel'>Pets allowed?
                        </h6>
                        <div className='d-inline mx-2'>
                          <label className='px-2 mainLabel' htmlFor="pets_yes">Yes</label>
                          <input
                            type='radio'
                            name="pets_allowed"
                            id="pets_yes"
                            value="true"
                            checked={form.pets_allowed === true}
                            onChange={handleChange}
                          />
                        </div>
                        <div className='d-inline mx-2'>
                          <label className='px-2 mainLabel' htmlFor="pets_no">No</label>
                          <input
                            type='radio'
                            name="pets_allowed"
                            id="pets_no"
                            value="false"
                            checked={form.pets_allowed === false}
                            onChange={handleChange}
                          />
                        </div>
                        {errors.pets_allowed && <small className="text-danger d-block mt-1">{errors.pets_allowed}</small>}
                      </div>
                    </div>

                    <div className='mb-3 col-md-3'>
                      <div className='radioButon'>
                        <h6 className='mainLabel'>Gatherings Allowed?</h6>
                        <div className='d-inline mx-2'>
                          <label className='px-2 mainLabel' htmlFor="gath_yes">Yes</label>
                          <input
                            type='radio'
                            name="gatherings_allowed"
                            id="gath_yes"
                            value="true"
                            checked={form.gatherings_allowed === true}
                            onChange={handleChange}
                          />
                        </div>
                        <div className='d-inline mx-2'>
                          <label className='px-2 mainLabel' htmlFor="gath_no">No</label>
                          <input
                            type='radio'
                            name="gatherings_allowed"
                            id="gath_no"
                            value="false"
                            checked={form.gatherings_allowed === false}
                            onChange={handleChange}
                          />
                        </div>
                        {errors.gatherings_allowed && <small className="text-danger d-block mt-1">{errors.gatherings_allowed}</small>}
                      </div>
                    </div>

                    <div className='mb-3 col-md-3'>
                      <div className='radioButon'>
                        <h6 className='mainLabel'>Children allowed?</h6>
                        <div className='d-inline mx-2'>
                          <label className='px-2 mainLabel' htmlFor="child_yes">Yes</label>
                          <input
                            type='radio'
                            name="children_allowed"
                            id="child_yes"
                            value="true"
                            checked={form.children_allowed === true}
                            onChange={handleChange}
                          />
                        </div>
                        <div className='d-inline mx-2'>
                          <label className='px-2 mainLabel' htmlFor="child_no">No</label>
                          <input
                            type='radio'
                            name="children_allowed"
                            id="child_no"
                            value="false"
                            checked={form.children_allowed === false}
                            onChange={handleChange}
                          />
                        </div>
                        {errors.children_allowed && <small className="text-danger d-block mt-1">{errors.children_allowed}</small>}
                      </div>
                    </div>

                    <div className='mb-3 col-md-12'>
                      <div className="form-group">
                        <label htmlFor="description" className='mainLabel'>Additional rules information (Optional)</label>
                        <textarea className='mainInput' name='additional_rules' maxLength={2000} value={form.additional_rules} onChange={handleChange}></textarea>
                      </div>
                    </div>
                  </div>


                  <div className='mb-3 col-md-12'>
                    <div className='stepButon d-flex justify-content-between'>
                      <button type="button" className="btn btn-secondary" onClick={() => handleStepChange(6)}>
                        Back
                      </button>
                      <div className="d-flex gap-2">
                        <button type="button" className="btn btn-outline-warning" onClick={handleSaveAsDraft} disabled={DraftLoading}>
                          {DraftLoading ? 'Saving...' : 'Save for Later'}
                        </button>
                        <button className="btn btn-primary" type="submit" disabled={AddListingLoading}>
                          {AddListingLoading ? 'Submitting...' : 'Submit'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              </form>

              <CustomModal
                show={showSuccessModal}
                close={() => setShowSuccessModal(false)}
                success
                heading="Listing added successfully."
              />
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};


